// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideShowContainerStyles } from "@sc/App/Widgets/SlideShow/SlideShowContainer";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

slideShowContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 317px;
        grid-gap: 20px 22px;

        ${xScreen("gte", "xl")} {
            grid-template-columns: 1fr 376px;
        }
    `,
};

slideShowContainerStyles.slideShowWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
    `,
};

slideShowContainerStyles.eSpotWrapper = {
    css: css`
        > div {
            height: 100%;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
    `,
};
